import { render, staticRenderFns } from "./serviceLines.vue?vue&type=template&id=48552867&scoped=true&"
import script from "./serviceLines.vue?vue&type=script&lang=js&"
export * from "./serviceLines.vue?vue&type=script&lang=js&"
import style0 from "./serviceLines.vue?vue&type=style&index=0&id=48552867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48552867",
  null
  
)

export default component.exports